import React, { useState } from 'react'
import Maybe from '../Maybe'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import validate from 'utils/validate';
import ReactTooltip from 'react-tooltip';

const Textarea = ({value, showCharacterLength, characterCount, maxLength, placeholder, onChange, className,validationName, rows, tagTextIsRed, tagTextClass, tagText, label, required, tooltip, checkFormValidation, defaultValue, containerClass, ...rest}) => {
    const [errors, setErrors] = useState({});
    
    const doValidation = (e) => {
        if (validationName !== undefined){
            const data = {[validationName]: e.target.value};
            const vErrors = validate(data);
            if (vErrors){
                setErrors(vErrors);
            }
            else{
                setErrors({});
            }
            checkFormValidation(undefined, validationName, e.target.value);
        }
    }
  return (
    <div className={`form-group ${containerClass || ""}`}>
        <Maybe condition={tooltip !== undefined}>
            <ReactTooltip id={label || ""} className="tooptip-size">
                {tooltip}
            </ReactTooltip>
        </Maybe>
        <Maybe condition={label !== "" && label !== " "}>
            <label>
                {label}
                <Maybe condition={required === true}>
                    <span className="form-input-required">*</span>
                </Maybe>
                <Maybe condition={tooltip !== undefined}>
                    <FontAwesomeIcon data-tip data-for={label || ""} icon="info-circle" className="ml-2 tip-icon text-ep-primary"/>
                </Maybe>
            </label>
        </Maybe>
        <div className='relative w-full'>
            <textarea
                rows={rows}
                style={{resize: "none"}}
                value={value}
                placeholder={placeholder}
                className={className}
                defaultValue={defaultValue}
                showcharacterlength={showCharacterLength?.toString()}
                charactercount={characterCount}
                maxLength={maxLength}
                onChange={(e) => {onChange(e); doValidation(e)}}
                {...rest}
            />
            <Maybe condition={showCharacterLength}>
                <div className='flex items-center space-x-2 absolute top-3 right-3 text-[#9CA3AF] text-[14px]'>
                    {characterCount} / {maxLength}
                </div>
            </Maybe>
            <span className={`text-xs transition-opacity duration-500 ${tagText?.length ? "opacity-100" : "opacity-0"} ${tagTextIsRed && "text-ep-danger-200"} ${tagTextClass}`}>{tagText}</span>
        </div>
        <Maybe condition={errors[validationName] !== undefined}>
            <div className="form-input-message">
                {errors[validationName]}
            </div>
        </Maybe>
    </div>
  )
}

export default Textarea